import { useEffect } from "react";
import { update4D } from "../../../../../AllEquipments/CommonFeatures/PMSTab2/4d/api";
import { build4DSyncBatchKey } from "./syncUtils";

export const use4DTaskSync = ({
  tasksToSync4D,
  accessToken,
  isSyncing4DRef,
  last4DSyncBatchKeyRef,
}) => {
  useEffect(() => {
    const sync4DTaskValues = async () => {
      if (!Array.isArray(tasksToSync4D) || tasksToSync4D.length === 0) {
        console.log("[4D Task Sync] No 2-level or 3-level ITP tasks to update.");
        return;
      }

      const batchKey = build4DSyncBatchKey(tasksToSync4D);

      if (!batchKey) {
        console.log("[4D Task Sync] Empty batch key. Nothing to update.");
        return;
      }

      if (isSyncing4DRef.current) {
        console.log("[4D Task Sync] Already syncing. Skip parallel run.");
        return;
      }

      if (last4DSyncBatchKeyRef.current === batchKey) {
        console.log("[4D Task Sync] Same batch already synced. Prevent loop.", {
          batchKey,
        });
        return;
      }

      isSyncing4DRef.current = true;
      last4DSyncBatchKeyRef.current = batchKey;

      console.log("[4D Task Sync] Started", {
        tasksCount: tasksToSync4D.length,
        tasks: tasksToSync4D.map(({ task, body }) => ({
          id: task?.id,
          taskCode: task?.taskCode,
          task: task?.task || task?.name,
          body,
        })),
      });

      const updateRequests = [];

      tasksToSync4D.forEach(({ task, body }) => {
        const taskId = task?.id;

        if (!taskId) {
          console.log("[4D Task Sync] Skipped task because ID is missing", {
            task,
          });
          return;
        }

        console.log("[4D Task Sync] Updating task", {
          taskId,
          taskCode: task?.taskCode,
          task: task?.task || task?.name,
          body,
        });

        updateRequests.push(
          update4D(taskId, body, accessToken)
            .then((result) => {
              console.log("[4D Task Sync] Update success", {
                taskId,
                taskCode: task?.taskCode,
                body,
                result,
              });

              return result;
            })
            .catch((error) => {
              console.error("[4D Task Sync] Update failed", {
                taskId,
                taskCode: task?.taskCode,
                body,
                error,
              });
            })
        );
      });

      try {
        if (updateRequests.length > 0) {
          await Promise.all(updateRequests);

          console.log("[4D Task Sync] Finished", {
            requestedUpdates: updateRequests.length,
          });
        } else {
          console.log("[4D Task Sync] Finished. No updates were needed.");
        }
      } finally {
        isSyncing4DRef.current = false;
      }
    };

    sync4DTaskValues();
  }, [tasksToSync4D, accessToken, isSyncing4DRef, last4DSyncBatchKeyRef]);
};
